import './hints.scss'

import React, {FunctionComponent} from 'react'
import {style} from 'util/campagne/style'
import {Theme} from 'views/campagne/theme'

export type HintsType = {
	title: string
	hints: Array<{hint: string}>
}
const styles = style('hints', ['hint'])

export const Hints: FunctionComponent<HintsType> = ({title, hints}) => {
	return (
		hints && (
			<div class={styles}>
				<Theme.H3 as="h4" mod={['white', 'slantedtoleft']}>
					{title}
				</Theme.H3>
				<ol class={styles('list')}>
					{Object.values(hints).map((obj) => (
						<li class={styles.hint}>
							<Theme.Wysiwyg mod="white">{obj.hint}</Theme.Wysiwyg>
						</li>
					))}
				</ol>
			</div>
		)
	)
}
